// export const BASEURL = 'http://cdp-local-api.dev.routeryuncs.com'

// 正式后台接口地址
export const BASEURL = 'https://cdp-local-api.cdp.shmedia.tech'
// 测试后台接口地址
// export const BASEURL = 'http://cdp-local-api.dev.routeryuncs.com'
// export const BASEURL = 'http://10.10.0.30:30086'
export const DISKSTORAGE = 4.88;
